<template>
  <div class="container">
    <content-header :data="[{text: '商品列表', path: '/product/manage'},{text:(curProduct.id ? '修改':'添加')+'商品', path: ''}]"></content-header>
    <div class="content">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="基本信息" name="base">
          <el-form :model="curProduct" :rules="productRules" ref="sampleForm" label-position="right" label-width="0px">
            <el-form-item prop="brand_id" label="商品品牌" :label-width="formLabelWidth">
              <el-select v-model="curProduct.brand_id" value-key="id" placeholder="请选择">
                <el-option
                  v-for="item in brandIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="category_id" label="商品分类" :label-width="formLabelWidth">
              <div class="scope-tags">
                <el-tag v-for="(item, index) in scoped" :key="item" :closable="true" @close="removeScope(index)">{{ item }}</el-tag>
              </div>
              <el-button icon="iconfont icon-add" @click="isScopeFilterShow = true">选择分类</el-button>
              <!-- 知识点选择 弹出框 -->
              <div class="scope-search">
                <div class="scope-prompt" v-if="isScopeFilterShow" @click.self="isScopeFilterShow = false">
                  <div class="prompt-box">
                    <i class="el-icon-close" @click="isScopeFilterShow = false"></i>
                    <el-input
                      class="scope-filter"
                      placeholder="输入关键字进行过滤"
                      v-model="scopeFilter">
                    </el-input>
                    <div class="scope-overflow">
                      <el-tree
                        show-checkbox
                        class="filter-tree"
                        :data="categoryOpts"
                        :props="defaultScope"
                        node-key="id"
                        :check-strictly="true"
                        default-expand-all
                        highlight-current
                        :default-checked-keys="scopedId"
                        :filter-node-method="filterNode"
                        @check-change="handleCheckChange"
                        ref="scopetree">
                      </el-tree>
                    </div>
                    <div class="scope-footer">
                      <el-button class="fn-right" type="primary" @click="isScopeFilterShow = false">确定</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="name" label="商品名称" :label-width="formLabelWidth">
              <el-input v-model="curProduct.name" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="curProduct.description" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item :label-width="formLabelWidth">
              <el-button type="primary" @click="confirmHandle">保存基本信息</el-button>
              <el-button @click="backHandle">返回商品列表</el-button>
              <!--el-button @click="cancelHandle">取 消</el-button-->
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="主图" name="mainImage">
          <template v-if="this.curProduct.id">
            <div class="action-bar">
              <el-upload
                class="upload-demo"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadMediaSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <el-button size="small" type="primary">点击上传主图</el-button>
                <div slot="tip" class="el-upload__tip">只能上传JPG/PNG文件，且大小不超过2M</div>
              </el-upload>
            </div>
            <el-table
              :data="mediaData"
              border
              stripe>
              <el-table-column
                fixed
                prop="id"
                label="ID"
                width="150">
              </el-table-column>
              <el-table-column
                label="图片">
                <template slot-scope="scope">
                 <el-popover
                  placement="right"
                  title=""
                  trigger="hover">
                  <img :src="domainPic + scope.row.url"/>
                  <img slot="reference" :src="domainPic + scope.row.url" :alt="scope.row.url" style="max-height: 50px;max-width: 130px">
                 </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="deleteMediaHandle(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            请先添加并保存商品基本信息
          </template>
        </el-tab-pane>
        <el-tab-pane label="详情图" name="detailImage">
          <template v-if="this.curProduct.id">
            <div class="action-bar">
              <el-upload
                class="upload-demo"
                action="//upload-z2.qiniup.com"
                :data="uploadForm"
                :show-file-list="false"
                :on-success="uploadMedia2Success"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <el-button size="small" type="primary">点击上传详情图</el-button>
                <div slot="tip" class="el-upload__tip">只能上传JPG/PNG文件，且大小不超过2M</div>
              </el-upload>
            </div>
            <el-table
              :data="media2Data"
              border
              stripe>
              <el-table-column
                fixed
                prop="id"
                label="ID"
                width="150">
              </el-table-column>
              <el-table-column
                label="图片">
                <template slot-scope="scope">
                 <el-popover
                  placement="right"
                  title=""
                  trigger="hover">
                  <img :src="domainPic + scope.row.url"/>
                  <img slot="reference" :src="domainPic + scope.row.url" :alt="scope.row.url" style="max-height: 50px;max-width: 130px">
                 </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="deleteMedia2Handle(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            请先添加并保存商品基本信息
          </template>
        </el-tab-pane>
        <el-tab-pane label="商品属性" name="attribute">
          <template v-if="this.curProduct.id">
            <div class="action-bar">
              <el-button type="default" icon="plus" size="small" @click="initNewAttributeHandle">添加</el-button>
            </div>
            <el-table
              :data="attributeData"
              border
              stripe>
              <el-table-column
                fixed
                prop="name"
                label="属性名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="value"
                label="属性值">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="initEditAttributeHandle(scope)" type="text" size="small" >修改</el-button>
                  <el-button @click="deleteAttributeHandle(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            请先添加并保存商品基本信息
          </template>
        </el-tab-pane>
        <el-tab-pane label="SKU" name="sku">
          <template v-if="this.curProduct.id">
            <div class="action-bar">
                <el-button type="default" icon="plus" size="small" @click="initNewSkuHandle">添加</el-button>
            </div>
            <el-table
              :data="skuData"
              border
              stripe>
              <el-table-column
                fixed
                prop="name"
                label="名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="quantity_available"
                label="库存">
              </el-table-column>
              <el-table-column
                prop="retail_price"
                label="厂商建议零售价">
              </el-table-column>
              <el-table-column
                prop="sale_price"
                label="销售价">
              </el-table-column>
              <el-table-column
                prop="external_id"
                label="外部ID">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="skuRowClick(scope.row)" type="text" size="small" >查看</el-button>
                  <el-button @click="initEditSkuHandle(scope)" type="text" size="small" >修改</el-button>
                  <el-button @click="deleteSkuHandle(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            请先添加并保存商品基本信息
          </template>
        </el-tab-pane>
      </el-tabs>
      <div class="new-wrap">
        <el-dialog :title="curAttribute.id ? '修改属性' : '添加属性'" :visible.sync="isAttributeShow">
          <el-form :model="curAttribute" :rules="attributeRules" ref="attributeForm" >

            <el-form-item prop="name" label="属性名" :label-width="formLabelWidth">
              <el-input v-model="curAttribute.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="name" label="属性值" :label-width="formLabelWidth">
              <el-input v-model="curAttribute.value" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isAttributeShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmAttributeHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curSku.id ? '修改Sku' : '添加Sku'" :visible.sync="isSkuShow">
          <el-form :model="curSku" :rules="skuRules" ref="skuForm" >
            <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
              <el-input v-model="curSku.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="quantity_available" label="库存" :label-width="formLabelWidth">
              <el-input v-model.number="curSku.quantity_available" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="retail_price" label="厂商建议零售价" :label-width="formLabelWidth">
              <el-input v-model="curSku.retail_price" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="sale_price" label="销售价" :label-width="formLabelWidth">
              <el-input v-model="curSku.sale_price" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="external_id" label="外部ID" :label-width="formLabelWidth">
              <el-input v-model="curSku.external_id" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <template v-if="this.curSku.id">
            <div style="border-top: 1px solid #d9d9d9;padding-top: 10px">
              <el-form :inline="true" size="mini">
                <el-form-item label="规格">
                  <el-input v-model="skuAttributeName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="规格值">
                  <el-input v-model="skuAttributeValue" auto-complete="off"></el-input>
                </el-form-item>
                 <el-form-item>
                  <el-button type="default" icon="plus"  @click="addSkuAttributeHandle">添加规格</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-table
              :data="skuAttributeData"
              border
              stripe>
              <el-table-column
                fixed
                prop="name"
                label="规格"
                width="150">
              </el-table-column>
              <el-table-column
                prop="value"
                label="规格值">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="200">
                <template slot-scope="scope">
                  <el-button @click="deleteSkuAttributeHandle(scope)" type="text" size="small" >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isSkuShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmSkuHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="view-wrap">
        <el-dialog title="Sku详细" :visible.sync="isSkuView">
          <sku-view :data="selectedSku"></sku-view>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isSkuView = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import { mapState } from 'vuex'
  import constants from 'config/constants'
  import date from 'utils/date'
  import CategoryModel from 'models/category'
  import BrandModel from 'models/brand'
  import ProductModel from 'models/product'
  import SkuModel from 'models/sku'
  import SkuView from 'components/SkuView'
  import CommonModel from 'models/common'

  export default {
    components: {
      SkuView
    },
    data () {
      return {
        activeTab: 'base',
        domainPic: constants.basic.domain_pic,
        curProduct: {
          id: '',
          name: '',
          category_id: '',
          brand_id: '',
          description: ''
        },
        brandIds: [],
        formLabelWidth: '120px',
        productRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          brand_id: [{ required: true, message: '请输入分类', trigger: 'blur' }],
        },
        scopedId: [],
        scoped: [],
        _scoped: [],
        isScopeFilterShow: false,
        scopeFilter: '',
        categoryOpts: [],
        defaultScope: {
          children: 'child',
          label: 'name'
        },
        //
        attributeData: [],
        customerIds: [],
        curAttribute: {
          id: '',
          name: '',
          value: '',
          product_id: '',
        },
        attributeRules: {
          name: [{ required: true, message: '请输入属性名', trigger: 'blur' }],
          value: [{ required: true, message: '请输属性值', trigger: 'blur' }],
        },
        isAttributeShow: false,
        isEdit: false,
        //
        skuData: [],
        isSkuShow: false,
        materialIds: [],
        curSku: {
          id: '',
          name: '',
          quantity_available: '',
          retail_price: '',
          sale_price: '',
          external_id: ''
        },
        skuRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          quantity_available: [{ required: true, message: '请输入数量', trigger: 'blur' },
            { type: 'number', message: '数量必须为数值' }],
          retail_price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
          sale_price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        },
        //
        isSkuView: false,
        selectedSku: {},
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        mediaData: [],
        media2Data: [],
        mediaUrl: '',
        mediaType: 1,
        //
        skuAttributeData: [],
        skuAttributeName: '',
        skuAttributeValue: '',
      }
    },
    created () {
      CategoryModel.find().then(res => {
        this.categoryOpts = res.category_tree
      })

      BrandModel.find().then(res => {
        this.brandIds = res.rows
        console.log(this.brandIds)
      })

      //
      this.curProduct.id = this.$route.query.id
      console.log(this.curProduct.id)
      if (this.curProduct.id) {
        ProductModel.get({
          id: this.curProduct.id
        }).then(res => {
          this.curProduct = res
          console.log(this.curProduct)
          if (res.category) {
            this.scopedId = res.category.map(item => item.id)
            this.scoped = res.category.map(item => item.name)
            this._scoped = res.category
            // console.log('========')
            // console.log(this.scopedId)
          }
        })

        //
        ProductModel.findAttribute({productId: this.curProduct.id}).then(res => {
          this.attributeData = res
        })
        ProductModel.findMedia({productId: this.curProduct.id, type: 1}).then(res => {
          this.mediaData = res
        })
        ProductModel.findMedia({productId: this.curProduct.id, type: 2}).then(res => {
          this.media2Data = res
        })
        SkuModel.find({addlProductId: this.curProduct.id}).then(res => {
          this.skuData = res.rows
        })
      }
      //
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    watch: {
      scopeFilter (val) {
        this.$refs.scopetree.filter(val)
      },
    },
    methods: {
      handleTabClick (tab, event) {
        console.log(tab, event)
      },
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadMediaSuccess (response, file, fileList) {
        this.saveMedia(1, response.key)
      },
      uploadMedia2Success (response, file, fileList) {
        this.saveMedia(2, response.key)
      },
      saveMedia (type, url) {
        ProductModel.createMedia({
          productId: this.curProduct.id,
          type: type,
          url: url
        }).then(res => {
          ProductModel.findMedia({productId: this.curProduct.id, type: type}).then(res => {
            if (type === 1) {
              this.mediaData = res
            } else {
              this.media2Data = res
            }
          })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'product'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'product'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log('=====++')
          console.log(this.uploadForm)
        }
        return true
      },
      backHandle () {
        this.$router.go(-1)
      },
      cancelHandle () {
        this.$router.go(-1)
      },
      newHandle () {
        ProductModel.create({
          name: this.curProduct.name,
          brandId: this.curProduct.brand_id,
          categoryId: this._scoped.map(item => item.id).join(','),
          description: this.curProduct.description
        }).then(res => {
          this.curProduct.id = res.id
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        ProductModel.update({
          id: this.curProduct.id,
          name: this.curProduct.name,
          brandId: this.curProduct.brand_id,
          categoryId: this._scoped.map(item => item.id).join(','),
          description: this.curProduct.description
        }).then(() => {
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      confirmHandle () {
        this.$refs.sampleForm.validate(valid => {
          if (!valid) return
          if (this.curProduct.id) return this.editHandle()
          this.newHandle()
        })
      },
      skuRowClick (row, event0, column) {
        SkuModel.findAttribute({skuId: row.id}).then(res => {
          this.selectedSku = row
          this.selectedSku.attribute_list = res
          this.isSkuView = true
          console.log(this.selectedSku)
        })
      },
      // product attribute ////////////////
      deleteAttributeHandle (item) {
        this.$confirm('确认删除 ' + item.row.name + '？')
          .then(_ => {
            ProductModel.deleteAttribute({
              id: item.row.id,
            }).then(() => {
              this.attributeData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmAttributeHandle () {
        this.$refs.attributeForm.validate(valid => {
          if (!valid) return
          if (this.isEdit) return this.editAttributeHandle()
          this.newAttributeHandle()
        })
      },
      initNewAttributeHandle () {
        this.curAttribute = {
          id: '',
          name: '',
          value: '',
          productId: this.curProduct.id
        }
        this.isEdit = false
        this.isAttributeShow = true
      },
      newAttributeHandle () {
        ProductModel.createAttribute(this.curAttribute).then(res => {
          ProductModel.findAttribute({productId: this.curProduct.id}).then(res => {
            this.attributeData = res
          })
          this.isAttributeShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditAttributeHandle (item) {
        this.curAttribute = {
          id: item.row.id,
          name: item.row.name,
          value: item.row.value,
          productId: item.row.productId
        }
        this.isEdit = true
        this.isAttributeShow = true
      },
      editAttributeHandle () {
        ProductModel.updateAttribute(this.curAttribute).then(res => {
          ProductModel.findAttribute({productId: this.curProduct.id}).then(res => {
            this.attributeData = res
          })

          this.isAttributeShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },

      // product sku ////////////////
      deleteSkuHandle (item) {
        this.$confirm('确认删除 ' + item.row.name + '？')
          .then(_ => {
            SkuModel.delete({
              id: item.row.id,
            }).then(() => {
              this.skuData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmSkuHandle () {
        this.$refs.skuForm.validate(valid => {
          if (!valid) return
          if (this.isEdit) return this.editSkuHandle()
          this.newSkuHandle()
        })
      },
      initNewSkuHandle () {
        this.curSku = {
          id: '',
          name: '',
          quantity_available: '',
          retail_price: '',
          sale_price: '',
          external_id: '',
          addl_product_id: this.curProduct.id
        }
        this.isEdit = false
        this.isSkuShow = true
      },
      newSkuHandle () {
        SkuModel.create({
          name: this.curSku.name,
          quantityAvailable: this.curSku.quantity_available,
          retailPrice: this.curSku.retail_price,
          salePrice: this.curSku.sale_price,
          externalId: this.curSku.external_id,
          addlProductId: this.curProduct.id,
          defaultProductId: this.curProduct.id
        }).then(res => {
          SkuModel.find({addlProductId: this.curProduct.id}).then(res => {
            this.skuData = res.rows
          })
          this.isSkuShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditSkuHandle (item) {
        this.curSku = item.row
        SkuModel.findAttribute({skuId: this.curSku.id}).then(res => {
          this.skuAttributeData = res
        })
        this.isEdit = true
        this.isSkuShow = true
      },
      editSkuHandle () {
        SkuModel.update({
          id: this.curSku.id,
          name: this.curSku.name,
          quantityAvailable: this.curSku.quantity_available,
          retailPrice: this.curSku.retail_price,
          salePrice: this.curSku.sale_price,
          externalId: this.curSku.external_id,
          addlProductId: this.curProduct.id,
          defaultProductId: this.curProduct.id
        }).then(res => {
          SkuModel.find({addlProductId: this.curProduct.id}).then(res => {
            this.skuData = res.rows
          })

          this.isSkuShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      addSkuAttributeHandle (item) {
        SkuModel.createAttribute({
          name: this.skuAttributeName,
          value: this.skuAttributeValue,
          skuId: this.curSku.id
        }).then(res => {
          this.skuAttributeName = ''
          this.skuAttributeValue = ''
          SkuModel.findAttribute({skuId: this.curSku.id}).then(res => {
            this.skuAttributeData = res
          })
        }).catch(err => {
          console.log(err)
          this.$message({ message: err.message, type: 'error' })
        })
      },
      deleteSkuAttributeHandle (item) {
        this.$confirm('确认删除 ' + item.row.name + '？')
          .then(_ => {
            SkuModel.deleteAttribute({
              id: item.row.id,
            }).then(() => {
              this.skuAttributeData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      //
      filterNode (value, data) {
        if (!value) return true
        return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      },
      handleCheckChange () {
        const _data = this.$refs.scopetree.getCheckedNodes()
        const _arr = getDeepData(_data).arr
        const _items = getDeepData(_data).items

        this.scopedId = _arr
        this._scoped = _items
        let arr = []
        this._scoped.forEach(item => {
          arr.push(item.name)
        })
        this.scoped = arr

        function getDeepData (data) {
          const arr = []
          const items = []
          pollData(data)
          function pollData (data) {
            for (let i = 0; i < data.length; i++) {
              if (arr.some(item => item === data[i].id)) continue
              arr.push(data[i].id)
              items.push(data[i])
            }
          }
          return {
            arr,
            items,
          }
        }
      },
      removeScope (index) {
        this.scopedId.splice(index, 1)
        this.scoped.splice(index, 1)
        this._scoped.splice(index, 1)
      },
      // product attribute ////////////////
      deleteMediaHandle (item) {
        this.$confirm('确认删除图片？')
          .then(_ => {
            this.deleteMedia(item.row.id, 1, item)
          })
          .catch(_ => {})
      },
      deleteMedia2Handle (item) {
        this.$confirm('确认删除图片？')
          .then(_ => {
            this.deleteMedia(item.row.id, 2, item)
          })
          .catch(_ => {})
      },
      deleteMedia (id, type, item) {
        ProductModel.deleteMedia({
          productMediaId: id,
          type: type
        }).then(() => {
          if (type === 1) {
            this.mediaData.splice(item.$index, 1)
          } else {
            this.media2Data.splice(item.$index, 1)
          }
          this.$message({ message: '删除成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding-top: 5px
    padding-left: 10px
    padding-right: 10px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .action-bar
      padding-bottom: 5px
    .new-wrap
      .el-input
        width: 85%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block
    .scope-tags
      display: inline-block
      vertical-align: middle
      .el-tag
        margin-right: 5px
    .scope-search
      width: 400px
      .el-select
        width: 100%
      .scope-prompt
        position: fixed
        left: 0
        top: 0
        right: 0
        bottom: 0
        z-index: 99
        background-color: rgba(0, 0, 0, .35)
        .prompt-box
          position: absolute
          left: 50%
          top: 50%
          width: 600px
          padding: 28px
          margin-left: -300px
          margin-top: -230px
          background-color: #fff
          border-radius: 4px
          .el-icon-close
            position: absolute
            right: 8px
            top: 8px
            cursor: pointer
          .scope-filter
            margin-bottom: 20px
          .scope-overflow
            padding: 10px
            max-height: 400px
            border: 1px solid #d1dbe5
            overflow-y: scroll
            .filter-tree
              border: 0
           .scope-footer
             margin-top: 10px
</style>



// WEBPACK FOOTER //
// src/views/ProductNew.vue